import { Component, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TypographyComponent } from '@/app/components/ui/typography.component';
import { AttendanceService } from '@/app/services/common/attendance.service';
import { LeaveService } from '@/app/services/common/leave.service';
import { forkJoin, of, catchError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from '@/app/services/common/notification.service';
import { AttendanceItem } from '@/types/attendance.interfaces';
import { LeaveData } from '@/types/leave.interfaces';
import { EmployeeService } from '@/app/services/common/employee.service';

export interface DashboardStatItem {
  label: string;
  subLabel?: string;
  value: string | number;
  icon: string;
}

@Component({
  selector: 'app-dashboard-stats',
  standalone: true,
  imports: [CommonModule, TypographyComponent],
  templateUrl: './dashboard-stats.component.html',
    styleUrls: ['./dashboard-stats.component.scss'],

})
export class DashboardStatsComponent implements OnInit {
  private attendanceService = inject(AttendanceService);
  private employeeService = inject(EmployeeService);
  private leaveService = inject(LeaveService);
  private notificationService = inject(NotificationService);

  stats = signal<DashboardStatItem[]>([]);
  isLoading = signal(false);

  ngOnInit() {
    this.fetchStats();
  }

  fetchStats() {
    this.isLoading.set(true);

    forkJoin({
      attendance: this.attendanceService.getAllAttendance().pipe(catchError(() => of({ data: [] }))),
      employee: this.employeeService.getAllEmployees().pipe(catchError(() => of({ data: [] }))),
      leaves: this.leaveService.getLeaves().pipe(catchError(() => of({ data: [] })))
    }).subscribe({
      next: (res) => {
        const attendanceData = res.attendance.data;
        const employeeData = res.employee.data;
        const totalEmployee = employeeData.length;
        const totalOntime = attendanceData.filter((attendance: AttendanceItem) => attendance.status === 'on_time').length;
        const totalPresents = attendanceData.length;
        const totalApprovedLeave = res.leaves.data.filter((leave: LeaveData) => leave.status === 'approved').length;

        this.stats.set([
          { label: 'Total Employee', value: totalEmployee, icon: 'pi pi-users' },
          { label: 'Total Ontime', value: totalOntime, icon: 'pi pi-file' },
          { label: 'Total Presents', value: totalPresents, icon: 'pi pi-user-plus' },
          { label: 'Total Leave', value: totalApprovedLeave, icon: 'pi pi-arrow-down-left' }
        ]);
        this.isLoading.set(false);
      },
      error: (err: HttpErrorResponse) => {
        this.notificationService.handleHttpError(err);
        this.isLoading.set(false);
      }
    });
  }
}
